const emailAddressRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default function isValidEmailAddress(emailAddress: string): boolean {
    //VSO: 1041: Separate out form field validation to a different package.
    return emailAddressRegex.test(emailAddress);
}
